import React, {useMemo} from 'react';
import {Card, CardActions, CardContent, Typography} from "@mui/material";
import {CardTitle} from "@atttomyx/react-components";
import "./wordCard.css";

const WordCard = (props) => {
    const { word, children } = props;

    const sus = useMemo(() => {
        return word.definitions.length < 1
            || word.sentences.length !== 3
            || !word.sentences.every(sentence => {
                const regex = new RegExp(`\\b${word.word}\\b`);

                return regex.test(sentence);
            });
    }, [word]);

    return <Card className="word-card" raised={true}>
        <CardContent>
            <CardTitle>
                <Typography variant="body1" className={sus ? "flagged" : undefined}>
                    {word.word}
                </Typography>
            </CardTitle>
            <div className="scrollable">
                <Typography variant="caption">
                    Definitions
                </Typography>
                <Typography variant="caption">
                    <ul className="bullets">
                        {word.definitions.map(item => <li key={item}>{item}</li>)}
                    </ul>
                </Typography>
                <Typography variant="caption">
                    Sentences
                </Typography>
                <Typography variant="caption">
                    <ul className="bullets">
                        {word.sentences.map(item => <li key={item}>{item}</li>)}
                    </ul>
                </Typography>
            </div>
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default WordCard;
